import { CommonModule } from '@angular/common';
import { Component, AfterViewInit, ElementRef, Renderer2, ViewChild, OnDestroy } from '@angular/core';
import { Check, Leaf, Activity, Brain, LucideAngularModule } from 'lucide-angular';

interface Product {
  id: number;
  name: string;
  category: string;
  price: number;
  rating: number;
  image: string;
}

@Component({
  selector: 'app-benifits',
  imports: [CommonModule, LucideAngularModule],
  templateUrl: './benifits.component.html',
  styleUrl: './benifits.component.scss'
})
export class BenifitsComponent implements AfterViewInit, OnDestroy {

  readonly LeafIcon = Leaf;
  readonly BrainIcon = Brain;
  readonly ActivityIcon = Activity;

  currentColor = '#4CAF50'; // Default color
  benefits = [
    {
      icon: 'leaf',
      title: "100% Organic",
      description: "Our products are made with premium organic ingredients, free from chemicals and pesticides."
    },
    {
      icon: 'activity',
      title: "Energy & Vitality",
      description: "Natural supplements that help boost your energy levels and support overall vitality."
    },
    {
      icon: 'brain',
      title: "Mental Clarity",
      description: "Support cognitive function and promote mental clarity with our specialized herbs."
    }
  ];

  checklist = [
    'Sustainably sourced ingredients',
    'Lab-tested for purity and potency',
    'Free from artificial additives',
    'Traditional formulations backed by science'
  ];

  private observer!: IntersectionObserver;

  constructor(private elRef: ElementRef) {}

  ngAfterViewInit() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-fade-in');
            entry.target.classList.remove('opacity-0');
            this.observer.unobserve(entry.target);
          }
        });
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
      }
    );

    const elements = this.elRef.nativeElement.querySelectorAll('.appear-on-scroll');
    elements.forEach((el: Element) => this.observer.observe(el));
  }

  ngOnDestroy() {
    const elements = this.elRef.nativeElement.querySelectorAll('.appear-on-scroll');
    elements.forEach((el: Element) => this.observer.unobserve(el));
  }
}
